import React, { Suspense } from "react";
import { Link } from 'gatsby'
import Seo from '../components/seo'
import { Container, Row, Col, Tooltip } from 'react-bootstrap'
import { HomeMeta } from '../data/metaData'
import Layout from '../components/layout/layout'
import OverlayTrigger from 'react-bootstrap/OverlayTrigger'

import { Animations } from '../components/animations'

import BannerImg from '../animations/home/Banner_BG.json'
import { StaticImage } from 'gatsby-plugin-image'
import LazyLoad from 'react-lazy-load'

// const AwardSingleLine = React.lazy(() => import("../components/award-single-line"));
const ClientsTestimonial = React.lazy(() => import('../components/clients-testimonial'))
const Facts = React.lazy(() => import('../components/facts'))
const OurClients = React.lazy(() => import('../components/our-clients'))
const Awards = React.lazy(() => import('../components/awards'))
const CaseStudy = React.lazy(() => import('../components/case-study'))
const BlogList = React.lazy(() => import("../components/blog/blog-list"));

export const Head = () => (
  <Seo
    title={HomeMeta.metaTitle}
    description={HomeMeta.metaDescription}
    ogTitle={HomeMeta.ogTitle}
    ogDescription={HomeMeta.ogDescription}
    ogType={HomeMeta.ogType}
    ogSiteName={HomeMeta.ogSiteName}
    ogImage={HomeMeta.ogImage}
    twitterCard={HomeMeta.twitterCard}
    twitterCreator={HomeMeta.twitterCreator}
    twitterTitle={HomeMeta.twitterTitle}
    twitterDescription={HomeMeta.twitterDescription}
    twitterImage={HomeMeta.twitterImage}
  />
)

const IndexNewPage = () => {
  const HomeBannerShadow = '../images/home-banner-shadow.webp'
  const outsourceservice = [
    {
      title: "Software development",
      keyname: "keyname",
      des: "We harness the power of technology to develop industry-focused custom software that unlocks the opportunities of tomorrow.",
      sub: [
        {
          tooltip1: "Healthcare",
          link1: "/healthcare-software-development.html",
          iconclass1: "healthcare"
        },
        {
          tooltip1: "Logistics",
          link1: "/logistics-software-development.html",
          iconclass1: "logistics"
        },
        {
          tooltip1: "Fintech",
          link1: "/financial-software-development.html",
          iconclass1: "finance"
        },
        {
          tooltip1: "Oil & Gas",
          iconclass1: "oil-gas"
        },
        {
          tooltip1: "Manufacturing",
          iconclass1: "manufacturing"
        },
        {
          tooltip1: "Many More",
          link1: "/software-development-company.html",
          iconclass1: "more"
        },
      ],
      mainlnk: "/software-development-company.html",
      mainlinktext: "Develop software"

    },
    {
      title: "Resource as a Service",
      des: "We have a pool of expert developers with practical experience in creating, fixing, and delivering world-class products on time.",
      keyname: "keyname",
      sub: [
        {
          tooltip1: "React",
          link1: "/hire-reactjs-developers.html",
          iconclass1: "react"
        },
        {
          tooltip1: "Angular",
          link1: "/hire-angularjs-developers.html",
          iconclass1: "angular"
        },
        {
          tooltip1: ".Net",
          link1: "/hire-dot-net-developers.html",
          iconclass1: "dot-net"
        },
        {
          tooltip1: "Node.js",
          link1: "/hire-nodejs-developers.html",
          iconclass1: "node-js"
        },
        {
          tooltip1: "Java",
          link1: "/java-development.html",
          iconclass1: "java"
        },
        {
          tooltip1: "Many More",
          link1: "/technology-stack.html",
          iconclass1: "more"
        },
      ],
      mainlnk: "/hire-dedicated-mobile-web-developers-team.html",
      mainlinktext: "Build your team"

    },
    {
      title: "DevOps",
      des: "We provide a comprehensive set of DevOps services like CI/CD, Microservices, platform as a service, and more.",
      keyname: "keyname",
      sub: [
        {
          tooltip1: "Cloud Consulting",
          link1: "/cloud-consulting.html",
          iconclass1: "cloud-consulting"
        },
        {
          tooltip1: "Cloud Migration",
          link1: "/cloud-migration.html",
          iconclass1: "cloud-migration"
        },
        {
          tooltip1: "Cloud Optimisation",
          link1: "/cloud-optimisation.html",
          iconclass1: "cloud-optimisation"
        },
      ],
      mainlnk: "/devops-consulting-services.html",
      mainlinktext: "Explore services"
    },
    {
      title: "IoT",
      des: "Developing smart IoT apps to simplify, improve, & automate business by connecting physical to digital, reducing cost.",
      mainlnk: "/internet-of-things-iot-applications-development-company.html",
      mainlinktext: "Build smart apps"
    },
    {
      title: "Product engineering",
      des: "From upgrading human experience to building innovative digital products, we engineer digital products that foster your business prowess and growth.",
      mainlnk: "/product-engineering-services.html",
      mainlinktext: "Engineer products"
    },
    {
      title: "Digital Transformation",
      des: "With our unique digital transformation approach, we help businesses transform and drive fundamental change to evolve quickly and seize tomorrow’s opportunities.",
      mainlnk: "/digital-transformation.html",
      mainlinktext: "Get digital or Modernize business"
    },
  ]
  const flipdata = [
    {
      iconclass: "finance",
      title: "Financial",
      des: "FinTech SaaS platform, Mobile wallet apps, Neobank apps, and other financial app development",
      backtitle: "Financial",
      backdes: "Our FinTech experts combine their technical skills with knowledge of finance to develop a cutting-edge solution that enhances the transactional process, leading to a significant increase in market share.",
      link: "/financial-software-development.html",
      linktext: "Explore our domain expertise"
    },
    {
      iconclass: "healthcare",
      title: "Healthcare",
      des: "Healthcare SaaS platform, Telemedicine app, mHealth apps, & other healthcare software development.",
      backtitle: "Healthcare",
      backdes: "Our team of healthcare software developers design software solutions that adhere to healthcare regulations, with the goal of enhancing patient outcomes, facilitating remote care, and streamlining medical workflows through automation.",
      link: "/healthcare-software-development.html",
      linktext: "Explore our domain expertise"
    },
    {
      iconclass: "logistics",
      title: "Logistics",
      des: "Warehouse management system, Fleet management system, Yard management system and other logistics software development.",
      backtitle: "Logistics",
      backdes: "Our experts in logistics software development utilize a tailored approach to build a system that can expand along with your logistics and transportation operations. Plus, drives profitability for your business.",
      link: "/logistics-software-development.html",
      linktext: "Explore our domain expertise"
    }

  ]
  return (
    <>
      <Layout>
        <section className='section min-vh-100 d-flex flex-column home-background-pattern'>
          <LazyLoad>
            <div
              style={{
                position: 'absolute',
                top: 0,
                left: 0,
                width: '100%',
                height: '100%',
                zIndex: -1
              }}
            >
              <Animations animation={BannerImg} />
            </div>
          </LazyLoad>
          <LazyLoad>
            <StaticImage
              style={{ position: 'absolute' }}
              className='section-background-image'
              loading='lazy'
              src={HomeBannerShadow}
              alt='Home banner pattren'
            />
          </LazyLoad>
          {/* <div style={{
            position: 'absolute',
            bottom: -15,
            left: -15,
            zIndex: -1,
            width: "50%",
            transform: "rotate(90deg)"
          }}>
            <Animations animation={BannerImg} />
          </div>
          <div style={{
            position: 'absolute',
            top: -15,
            right: -15,
            zIndex: -1,
            width: "50%",
            transform: "rotate(-90deg)"
          }}>
            <Animations animation={BannerImg} />
          </div> */}
          <Container className='my-auto d-flex flex-column py-5 text-center'>
            <h1 className='sub-title mb-3'>
              Custom Software Development Company
            </h1>
            <h2 className='mb-4 font-size-64'>
              Business solutions for now and a tomorrow{' '}
              <span className='text-primary'>built on technology</span>
            </h2>
            <p className='lead mb-0 max-width-950 mx-auto'>
              We thrive to help businesses around the globe to accelerate
              digital transformation by crafting technology solutions that
              helps them solve problems and the world run better.
            </p>
            {/* <Link to="/request-quote.html" className="btn btn-lg btn-primary-theme-outline mt-4">
                  Build Your Team
                </Link> */}
          </Container>
          {/* <div className='py-md-4'>
            <LazyLoad height={120}>
              <AwardSingleLine />
            </LazyLoad>
          </div> */}
        </section>
        <section className='section bg-light'>
          <Container className='py-5'>
            <div className='mb-4 pb-1'>
              <h2 className='mb-4 '>
                Software development{' '}
                <span className='text-primary'>outsourcing services</span>
              </h2>
              <p className=' max-width-950  lead'>
                We are committed to building software compatible with our
                client’s business needs.
              </p>
            </div>
            <Row className='g-4' xs={1} sm={1} md={2} lg={3}>
              {
                outsourceservice.map((item, index) => (
                  <Col key={index}>
                    <div className='dark-box-2 equal-height d-flex flex-column'>
                      <h3 className=' mb-3 font-size-24'>
                        {item.title}
                      </h3>
                      <p className={`${(index === 3 || index === 4 || index === 5) ? "" : "mb-4"}`}>
                        {item.des}
                      </p>
                      {
                        item.keyname ?
                          <div className='mb-3'>
                            <Row className='g-3' xs={3} sm={4} lg={3} xl={4} xxl={6}>
                              {

                                item.sub.map((item, index) => (
                                  <Col className='text-center' key={index}>
                                    <OverlayTrigger
                                      placement='top'
                                      overlay={<Tooltip>{item.tooltip1}</Tooltip>}
                                    >
                                      {
                                        item.link1 ?
                                          <Link
                                            to={item.link1}
                                            aria-label={item.tooltip1}
                                            className=' force-hover d-inline-block'
                                          >
                                            <i className={`technologies-sprite-icon ${item.iconclass1} icon-size-50`} >
                                            </i>
                                          </Link> :
                                          <div className=' d-inline-block'>
                                            <i className={`technologies-sprite-icon ${item.iconclass1} icon-size-50`}></i>
                                          </div>
                                      }
                                    </OverlayTrigger>
                                  </Col>
                                ))

                              }
                            </Row>
                          </div> :
                          null
                      }
                      <div className='text-start mt-auto'>
                        <Link
                          to={item.mainlnk ? item.mainlnk : null}
                          className='btn btn-link px-0'
                        >
                          <span>{item.mainlinktext}</span>{' '}
                          <i className='icon ms-2 zmdi zmdi-hc-lg zmdi-long-arrow-right'></i>
                        </Link>
                      </div>
                    </div>
                  </Col>
                ))
              }

              {/* <Col className="text-center">
                          <Link to="/hire-vuejs-developers.html" aria-label="Healthcare" className=" force-hover d-inline-block">
                            <i className="{/* <Col className="tex-sprite-icon vue-js icon-size-50"></i>
                            <p className="font-size-12">Vue.JS</p>
                          </Link>
                        </Col>
                        <Col className="text-center">
                          <div className=" d-inline-block">
                            <i className="technologies-sprite-icon html-5 icon-size-50"></i>
                            <p className="font-size-12">HTML5</p>
                          </div>
                        </Col>
                        <Col className="text-center">
                          <div className=" d-inline-block">
                            <i className="technologies-sprite-icon java-script icon-size-50"></i>
                            <p className="font-size-12">JavaScript</p>
                          </div>
                        </Col>
                        <Col className="text-center">
                          <div className=" d-inline-block">
                            <i className="technologies-sprite-icon type-script icon-size-50"></i>
                            <p className="font-size-12">TypeScript</p>
                          </div>
                        </Col>
                        <Col className="text-center">
                          <Link to="/hire-laravel-developer.html" aria-label="Healthcare" className=" force-hover d-inline-block">
                            <i className="Col className="tex-sprite-icon laravel icon-size-50"></i>
                            <p className="font-size-12">Laravel</p>
                          </Link>
                        </Col>
                        <Col className="text-center">
                          <Link to="/hire-python-developers.html" aria-label="Healthcare" className=" force-hover d-inline-block">
                            <i className="Col className="tex-sprite-icon python icon-size-50"></i>
                            <p className="font-size-12">Python</p>
                          </Link>
                        </Col>
                        <Col className="text-center">
                          <Link to="/php-application-development.html" aria-label="Healthcare" className=" force-hover d-inline-block">
                            <i className="Col className="tex-sprite-icon php icon-size-50"></i>
                            <p className="font-size-12">PHP</p>
                          </Link>
                        </Col> */}
            </Row>
          </Container>
        </section>
        <Suspense fallback={<div>Loading...</div>}>
          <ClientsTestimonial
            title='Our valued <span class="text-primary">clients</span>'
            description='Our esteemed global clients praised us loud for using our range of software development services.'
            sectionClass='bg-white'
          />
        </Suspense>
        <Suspense fallback={<div>Loading...</div>}>
          <Facts sectionClass='bg-light' />
        </Suspense>
        <Suspense fallback={<div>Loading...</div>}>
          <OurClients sectionClass="bg-white" />
        </Suspense>
        <Suspense fallback={<div>Loading...</div>}>
          <LazyLoad offset={300}>
            <Awards sectionClass='bg-light' />
          </LazyLoad>
        </Suspense>
        <section className='section'>
          <Container className='py-5'>
            <div className='mb-4 pb-1'>
              <h2 className='mb-4 '>
                <span className='text-primary'>Industries</span> we empower
              </h2>
              <p className=' max-width-950  lead'>
                We transform unique ideas into powerful interfaces that meet
                the future demands of various industries.
              </p>
            </div>
            <Row as="ul" xs={1} md={2} lg={3} className="list-unstyled industries-flip-hover-box g-4">
              {
                flipdata.map((item, index) => (
                  <Col as="li" key={index}>
                    <Link to={item.link} className="flip-card dark-box-1 p-0 rounded-3 equal-height">
                      <div className="flip-card-inner">
                        <div className="flip-card-front p-4">
                          <i className={`mobile-application-sprite-icon ${item.iconclass} icon-size-70 mb-3`}></i>
                          <h3 className="h4  mb-3">{item.title}</h3>
                          <p className="text mb-0">{item.des}</p>
                        </div>
                        <div className="flip-card-back p-4">
                          <h3 className="h4  mb-3">{item.backtitle}</h3>
                          <p>{item.backdes}</p>
                          <span className="btn btn-link px-0">
                            <span>{item.linktext}</span> <i className="icon ms-2 zmdi zmdi-hc-lg zmdi-long-arrow-right"></i>
                          </span>
                        </div>
                      </div>
                    </Link>
                  </Col>
                ))
              }
            </Row>
          </Container>
        </section>
        <Suspense fallback={<div>Loading...</div>}>
          <LazyLoad offset={300}>
            <CaseStudy
              // category='Social, Healthcare & Fitness'
              sectionClass='bg-light'
            />
          </LazyLoad>
        </Suspense>
        {/* <section className="section bg-light">
          <Container className="py-5">
            <div className="text-center py-lg-5">
              <h2 className="mb-4  font-size-64">
                Get a glimpse of <span className="text-primary">our work</span>
              </h2>
              <p className=" max-width-950  lead mx-auto">All our case studies describe all the important aspects of a solution like its idea, design, and features. It also mentions the challenges that we faced and how we overcame with appropriate solutions.</p>
              <Link to="/works.html" className="btn btn-lg btn-primary-theme-outline mt-4">
                See Our Work
              </Link>
            </div>
          </Container>
        </section> */}
        <Suspense fallback={<div>Loading...</div>}>
          <LazyLoad offset={300}>
            <BlogList
              sectionClass="bg-white"
            // category='Angular, Hire developer'
            />
          </LazyLoad>
        </Suspense>
      </Layout >
    </>
  )
}

export default IndexNewPage
